import { useCallback, useEffect, useState } from 'react';
import { workflowService } from '../api/workflowService';
import type { DefinitionFullDetail, WorkflowDefinition } from '../api/types';

export const useWorkflowDefinitions = (publishedOnly = false) => {
  const [data, setData] = useState<WorkflowDefinition[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await workflowService.listDefinitions(publishedOnly));
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, [publishedOnly]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
};

export const useWorkflowDefinition = (definitionId?: string) => {
  const [data, setData] = useState<DefinitionFullDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    if (!definitionId) {
      setData(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      setData(await workflowService.getDefinitionFull(definitionId));
    } catch (err) {
      setError(err as Error);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [definitionId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
};
